export default "__VITE_ASSET__b575e857__"